import { Component, OnDestroy, OnInit } from '@angular/core';
import { AssignedContact, EventDetail } from '../../contacts/shared/models/Contact';
import { DetailsService } from '../details.service';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import * as moment from 'moment';
import { IState } from '../../shared/models/state';
import { Store } from '@ngrx/store';
import { getLimitsSelector } from '../../shared/limits/limits.reducer';
import { AccountLimits } from '../../account/account.model';
import { hideRecordingsNotAvailableInPlan } from '../../shared/limits/limitsHelper';

@Component({
  selector: 'cc-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss']
})
export class EventDetailsComponent implements OnInit, OnDestroy {
  public eventId: number;
  public recordUrl: string;
  public event: EventDetail;
  public assignedContacts: AssignedContact[];
  public voiceMailFileName: string;
  public spinnerVisible: boolean;
  public recordingEvents = [
    'REFUSE',
    'INCOMING_CALL',
    'INCOMING_CALL_ANSWERED',
    'INCOMING_CALL_REDIRECTED',
    'INCOMING_CALL_NOT_ANSWERED',
    'CONFERENCE_CALL',
    'TRANSFER_CALL'
  ];
  public noRecordingsTypes = [
    'BUSY',
    'NOT_ANSWERED',
    'FAILED',
    'INCOMING_CALL_FAILED',
    'INCOMING_CALL_VOICEMAIL',
    'FAILED_CONNECT_AGENT'
  ];
  private recordingsStorageDays = 0;
  private eventFetchTimeoutId = null;

  constructor(public detailsService: DetailsService, private store: Store<IState>) {}

  ngOnInit() {
    this.detailsService.onSetEventId.subscribe(id => {
      this.eventId = id;
    });
    this.store.select(getLimitsSelector).subscribe((limits: AccountLimits) => {
      this.recordingsStorageDays = limits.recordingsStorageDays;
    });
    this.loadEvent();
  }

  ngOnDestroy() {
    if (this.eventFetchTimeoutId) {
      window.clearTimeout(this.eventFetchTimeoutId);
    }
  }

  loadEvent() {
    this.detailsService.getEventDetails(this.eventId).subscribe((eventDetail: EventDetail) => {
      this.event = hideRecordingsNotAvailableInPlan(this.recordingsStorageDays, eventDetail);
      this.spinnerVisible =
        !eventDetail.recordingAvailable &&
        this.recordingEvents.includes(this.event.type) &&
        !this.noRecordingsTypes.includes(this.event.finishType);

      if (this.event && this.event.contacts) {
        this.assignedContacts = this.event.contacts.map((item: AssignedContact) => {
          const contactNumber = this.getEmphasizedNumber(item.alternativeMsisdns);
          const parsedNumber = parsePhoneNumberFromString(contactNumber);

          return {
            ...item,
            extendedMsisdns: {
              msisdn: contactNumber ? this.detailsService.getFormatedNumber(contactNumber) : null,
              isoCountry:
                contactNumber && parsedNumber && parsedNumber.country ? parsedNumber.country.toLowerCase() : null
            }
          };
        });
      }
      if (this.event && this.event.callId) {
        this.recordUrl = this.detailsService.getRecordingUrl(this.event.callId);
        this.voiceMailFileName = this.detailsService.createVoicemailFilename(this.event);
      }
      this.event.createdAt = moment(this.event.createdAt).format('LTS,  L');
    });

    if (
      !this.event ||
      (this.event && this.recordingEvents.includes(this.event.type) && !this.event.recordingAvailable)
    ) {
      this.eventFetchTimeoutId = setTimeout(() => {
        this.loadEvent();
      }, 20000);
    }
  }

  getEmphasizedNumber(list, compareNumber = this.event.clientMsisdn) {
    const toCompare = compareNumber.replace(/\s/g, '');
    if (compareNumber) {
      return list.filter(number => number === toCompare)[0];
    } else {
      return list[0];
    }
  }
}
